export default __webpack_public_path__ + "static/media/Search2.896b8787.svg";